// extracted by mini-css-extract-plugin
export default {"container":"Departments_container__+2HmK","transparent":"Departments_transparent__PPFjJ"};